export default __webpack_public_path__ + "static/media/green-check.0f5c38ff.svg";